import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './InboxStatusTabs.css';

// TODO: add 'cases' once the Cases tab is introduced
export type InboxTab = 'inbox' | 'archived';

interface Props {
  activeTab: InboxTab;
  onTabChange: (tab: InboxTab) => void;
  unreadCount?: number;
  archivedCount?: number;
}

export default function InboxStatusTabs({
  activeTab,
  onTabChange,
  unreadCount = 0,
  archivedCount = 0,
}: Props) {
  const tabs: { key: InboxTab; label: string; icon: IconDefinition; badgeCount: number }[] = [
    { key: 'inbox', label: 'Inbox', icon: faInbox, badgeCount: unreadCount },
    { key: 'archived', label: 'Archived', icon: faBoxArchive, badgeCount: archivedCount },
    // TODO: { key: 'cases', label: 'Cases', icon: faGavel, badgeCount: openCases },
  ];

  return (
    <div className="inbox-status-tabs">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`inbox-status-tab ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onTabChange(tab.key)}
          type="button"
        >
          <FontAwesomeIcon icon={tab.icon} className="inbox-tab-icon" />
          <span className="inbox-tab-label">{tab.label}</span>
          {tab.badgeCount > 0 && (
            <span className="inbox-tab-badge">{tab.badgeCount}</span>
          )}
        </button>
      ))}
    </div>
  );
}
